<template>
    <div class="md:relative">
        <div class="w-[45px] h-[45px] bg-gray-100 lg:bg-transparent cursor-pointer p-2 lg:p-1.5 rounded-md hover:bg-blue/5 hover:shadow-md" @click="toggleOverlay">
            <div class="flex flex-row gap-2 items-center justify-center align-middle">
                <div class="block text-lg">{{ getCurrencySymbol(activeCurrency) }}</div>
            </div>
        </div>

        <TransitionExpand v-show="optionOpened" class="absolute left-2 top-full min-w-[240px] max-w-[340px] z-10">
            <div class="bg-white shadow-md rounded-md p-3 space-y-2">
                <div class="mt-2">
                    <label for="currency" class="text-xs font-bold mt-2">{{ $t('lang_currency') }}:</label>
                    <div>
                        <select v-model="tempCurrency" class="mt-1 w-full border border-gray-300 rounded-md p-1">
                            <option v-for="currency in currencies" :key="currency.id" :value="currency.id">{{ currency.id }} • {{ currency.symbol }} • {{ currency.name }}</option>
                        </select>
                    </div>
                </div>

                <div class="text-center mt-4">
                    <button class="btn primary flex items-center gap-3 w-full justify-center" aria-labelledby="button" @click="saveSelection">
                        {{ $t('plain_save') }}
                    </button>
                </div>
            </div>
        </TransitionExpand>
    </div>
</template>

<script>
import i18next from 'i18next';
import { loadLanguageAsync } from 'laravel-vue-i18n';
import { mapGetters } from 'vuex';
import { getQueryParameterByName } from '../../helpers';

export default {
    data: () => ({
        activeLanguage: window.meta.region_configuration.language,
        activeCurrency: null,
        tempCurrency: null,
        optionOpened: false,
        currencies: []
    }),
    computed: {
        ...mapGetters('user', {
            user: 'get'
        })
    },
    watch: {
        '$store.state.user.user': function (newUser, oldUser) {
            if (newUser && !oldUser) {
                this.initializeData();
            }
        }
    },
    async mounted() {
        document.addEventListener('click', this.handleClickOutside);
        this.initializeData();
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    },

    methods: {
        // load stored currency, language and icon
        initializeData() {
            // Overwrite Currency if query parameter is set
            const queryCurrency = getQueryParameterByName('selectedCurrency');

            if (queryCurrency !== undefined && queryCurrency !== null) {
                window.meta.currency = queryCurrency;
            } else if (localStorage.getItem('selectedCurrency')) {
                window.meta.currency = localStorage.getItem('selectedCurrency');
            }

            if (window.meta.authenticated) {
                this.$store.dispatch('user/update_meta', {
                    currency: window.meta.currency,
                    language: this.activeLanguage
                });
            }

            this.activeCurrency = window.meta.currency;

            loadLanguageAsync(this.activeLanguage);
            i18next.changeLanguage(this.activeLanguage);

            // set currencies
            if (this.$root.$currencyData) {
                // ensure this is loaded
                this.currencies = Object.entries(this.$root.$currencyData).map(([id, { symbol, de, en }]) => ({
                    id,
                    symbol,
                    name: this.activeLanguage === 'de' ? de : en
                }));
            }

            // set temp values
            this.tempCurrency = this.activeCurrency;

            document.addEventListener('click', this.handleClickOutside);
        },

        // get currency symbol by id
        getCurrencySymbol(currencyId) {
            const currency = this.currencies.find((curr) => curr.id === currencyId);

            return currency ? currency.symbol : '';
        },
        // toggle language and currency selection overlay
        toggleOverlay() {
            this.tempCurrency = this.activeCurrency;
            this.optionOpened = !this.optionOpened;
        },
        async saveSelection() {
            if (window.meta.authenticated) {
                await this.$store.dispatch('user/update_meta', {
                    language: this.activeLanguage ?? 'de',
                    currency: this.tempCurrency
                });
            }

            localStorage.setItem('selectedCurrency', this.tempCurrency);

            window.location.reload();
        },
        // close language and currency selection overlay when clicked outside
        handleClickOutside(event) {
            const el = this.$el;
            const overlayElement = el && typeof el.querySelector === 'function' ? el.querySelector('.absolute') : null;
            const toggleButton = el && typeof el.querySelector === 'function' ? el.querySelector('.cursor-pointer') : null;

            if (overlayElement && !overlayElement.contains(event.target) && toggleButton && !toggleButton.contains(event.target)) {
                this.optionOpened = false;
            }
        }
    }
};
</script>
